import Repository from '@/repositories/Repository'
import Notifications from '@/models/Notifications'

export type NotificationsParams = {
  afterId: string // 省略可能、現在取得している通知の最後のIDを指定すると、それ以降の通知を出力する
  weatherWarning: {
    // 気象警報の通知の取得
    areaCodes: string[] // 該当のエリアコードの配列
  }
  threshold: {
    // 閾値超過の通知の取得
    stationIds: string[] // 該当の局IDの配列
  }
}

class NotificationsRepository extends Repository {
  constructor() {
    super('/notification')
  }

  async fetch(params: NotificationsParams) {
    const attributes = await super._post<NotificationsParams>(params)

    return new Notifications(attributes.items)
  }
}

export default NotificationsRepository
